import { CardId } from '@nemuru-eng/js-api-client';

export const NIE_EU_CARD_ID = CardId.PERMANENT;

export const NIE_EU_EXPIRATION_DATE_CARD = '2099-12-12';

export const NIE_EU_EXPIRATION_DATE_CARD_DATE = new Date(NIE_EU_EXPIRATION_DATE_CARD);
